import CustomDatePicker from './CustomDatePicker';
import CustomSearchInput from './CustomSearchInput';
import CustomSelect from './CustomSelect';

function FilterField({
  label,
  name,
  value,
  onChange,
  type = 'text',
  placeholder,
  options,
  suggestions,
}) {
  return (
    <div className="grid min-w-0 gap-1.5">
      {type === 'date' ? (
        <CustomDatePicker
          label={label}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
      ) : suggestions ? (
        <CustomSearchInput
          label={label}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          suggestions={suggestions}
        />
      ) : options ? (
        <CustomSelect
          label={label}
          name={name}
          value={value}
          onChange={onChange}
          options={options}
          searchable={false}
        />
      ) : (
        <label className="grid min-w-0 gap-2">
          <span className="text-[0.74rem] font-medium text-[var(--theme-text-muted)]">{label}</span>
          <input
            className="min-h-[40px] min-w-0 rounded-full border border-[var(--theme-border)] bg-white px-3 py-2 text-[0.84rem] outline-none placeholder:text-[var(--theme-text-muted)] focus:border-[var(--theme-accent)] focus:ring-2 focus:ring-[var(--theme-accent-soft)]"
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
          />
        </label>
      )}
    </div>
  );
}

export default FilterField;
